import React from 'react'
import { ReactComponent as LanguageIcon } from 'assets/icons/language.svg'
import Header from '../Header/Header'
import { LANGUAGE_OPTIONS } from '../../data/settingsData'
import s from './Language.module.scss'

export const Language = ({ goBack }) => (
	<>
		<Header
			title="Language & region"
			description="Language choices are being prepared for a future Kandor release."
			onBack={goBack}
		/>
		<section className={s.language__card}>
			<span className={s.language__icon}>
				<LanguageIcon aria-hidden />
			</span>
			<div>
				<span className={s.language__eyebrow}>Coming soon</span>
				<h2 className={s.language__title}>Work in the language that feels natural.</h2>
				<p className={s.language__description}>
					Kandor will support English, Arabic (RTL), Japanese and Vietnamese.
					Regional dates, timezones and number formats will follow your school’s
					settings.
				</p>
			</div>
			<div className={s.language__grid}>
				{LANGUAGE_OPTIONS.map(language => (
					<div key={language.name} className={s.language__option}>
						<strong className={s.language__code}>{language.code}</strong>
						<span className={s.language__name}>{language.name}</span>
						<small className={s.language__status}>{language.status}</small>
					</div>
				))}
			</div>
		</section>
	</>
)

export default Language
